import {useId} from 'react';

/**
 * id, которым подпись связана с полем. Берётся из useId: он одинаковый при серверном и клиентском рендере,
 * а общий счётчик на сервере и в браузере досчитывал до разного и сбивал гидратацию.
 */
export function useUniqueId(prefix: string = '') {
	return `${prefix}-${useId()}`;
}
